import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import RichText from "@/components/feature/RichText";
import { useSiteData } from "@/context/SiteDataContext";

export default function Terminos() {
  const { data } = useSiteData();
  const hero = data.pages.terminos;

  return (
    <Layout>
      <PageHero titulo={hero.hero_titulo} descripcion={hero.hero_descripcion} />

      <section className="bg-background-50">
        <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-20 text-foreground-700 leading-relaxed">
          <RichText text={hero.body_rich_text ?? ""} />
        </div>
      </section>
    </Layout>
  );
}
